import { render, staticRenderFns } from "./BaseComponent.vue?vue&type=template&id=af6b28de&scoped=true"
import script from "./BaseComponent.vue?vue&type=script&lang=js"
export * from "./BaseComponent.vue?vue&type=script&lang=js"
import style0 from "./BaseComponent.vue?vue&type=style&index=0&id=af6b28de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6b28de",
  null
  
)

export default component.exports